export const filtersUtil = {
    updatePromoFilters: (data, key, payload) =>
        data.map(filter => {
            const updatedFilter = { ...filter }
            if (updatedFilter.key === key) {
                updatedFilter['post_value'] = payload
                updatedFilter['display_value'] = payload
            }
            return updatedFilter
        }),
}
